import Svg, { Circle, G, Path } from 'react-native-svg'
const DocumentWithDot = (props) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={26} fill="none" {...props}>
    <G strokeWidth={2}>
      <Path
        stroke="#fff"
        d="M5 6a2 2 0 0 1 2-2h8.11a2 2 0 0 1 1.486.662l.904 1.005.987 1.096A2 2 0 0 1 19 8.1V22a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6Z"
      />
      <Path stroke="#fff" strokeLinecap="round" d="M10 13.667h2.143M10 18h4.286" />
      <Circle cx={18} cy={6} r={5} fill="#E30513" stroke="#000" />
    </G>
  </Svg>
)
export default DocumentWithDot
